import { Box, Button, makeStyles } from "@material-ui/core";

import AddIcon from "@material-ui/icons/AddCircleOutline";
import { useHistory } from "react-router-dom";
import { useTranslate } from "react-admin";

const useStyles = makeStyles((theme) => ({
  button: {
    backgroundColor: theme.potentialBlue,
    borderRadius: 18,
    width: 140,
    minHeight: 35,
    height: 35,
    fontSize: 14,
    color: theme.white,
    lineHeight: "1.1rem",
    "&:hover": {
      backgroundColor: theme.darkBlue,
    },
  },
  icon: {
    width: 20,
    height: 20,
    color: theme.white,
  },
}));
const AddPotentialButton = () => {
  const history = useHistory();
  const classes = useStyles();
  const translate = useTranslate();
  return (
    <Box>
      <Button
        variant="contained"
        className={classes.button}
        startIcon={<AddIcon className={classes.icon} />}
        onClick={() => history.push("/ci/potential/register")}
        noWrap
      >
        {translate("ra.text.ci.addPotential")}
      </Button>
    </Box>
  );
};

export default AddPotentialButton;
